module.exports = __webpack_public_path__ + "named-7f9a0980bc188f95c17b9bee87a6d6d9-apple-touch-icon-72x72.png";